'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from '../styles/Disclaimer.module.css';

const Disclaimer = () => {
  const disclaimerRef = useRef(null);
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    
    const disclaimer = disclaimerRef.current;
    if (!disclaimer) return;
    
    // Create the timeline with ScrollTrigger
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: disclaimer,
        start: "top 80%",
        end: "bottom 80%",
        toggleActions: "play none none reverse"
      },
    });
    
    // Animate the disclaimer content
    tl.fromTo(disclaimer, {
      opacity: 0,
      y: 20
    }, {
      opacity: 1,
      y: 0,
      duration: 0.8
    });
    
  }, []);
  
  return (
    <section className={styles.disclaimer} ref={disclaimerRef}>
      <div className={styles.container}>
        <h3 className={styles.title}>DISCLAIMER</h3>
        <p className={styles.text}>
        GAM is a utility token for the GameMax ecosystem, enabling platform access, governance, and rewards—not an investment promising returns. Conduct your own due diligence. Subject to applicable laws.
        </p>
      </div>
    </section>
  );
};

export default Disclaimer; 